export default "__VITE_ASSET__wMH6TyL1__"